import { render, staticRenderFns } from "./friendWelcomeMessage.vue?vue&type=template&id=473f6a5a&scoped=true"
import script from "./friendWelcomeMessage.vue?vue&type=script&lang=js"
export * from "./friendWelcomeMessage.vue?vue&type=script&lang=js"
import style0 from "./friendWelcomeMessage.vue?vue&type=style&index=0&id=473f6a5a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473f6a5a",
  null
  
)

export default component.exports